import React from 'react'
import styled from 'styled-components'
import MuiButton from '@material-ui/core/Button'

const Button = styled(MuiButton)``

export default React.memo(Button)
